module.exports = __webpack_public_path__ + "img/hairdresser1rounded.116bed7d.webp";